import { ChangeEvent } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { BoardInstructionTypes } from 'types/Board';
import { BoardInstruction, BoardOrder } from 'types';

import voteTypes from 'constants/voteTypes';
import voteValues from 'constants/voteValues';

import DelegationPartnerVoteOption from './DelegationPartnerVoteOption';
import DelegationPartnerInstructionOption from './DelegationPartnerInstructionOption';

type DelegationPartnerInstructionsProps = {
  orders: BoardOrder[];
  instructions: BoardInstruction[];
  instructionType: BoardInstructionTypes;
  onSaveInstruction: (vote: string, index: number) => void; // eslint-disable-line no-unused-vars
  onChangeInstructionType: (
    instructionType: BoardInstructionTypes | string // eslint-disable-line no-unused-vars
  ) => void;
};

const DelegationPartnerInstructions = ({
  orders,
  instructions,
  instructionType,
  onSaveInstruction,
  onChangeInstructionType,
}: DelegationPartnerInstructionsProps) => {
  const { t } = useTranslate();

  const handleChangeInstructionType = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    onChangeInstructionType(event.target.value);
  };

  const handleSaveInstruction = (vote: string, index: number) => {
    onSaveInstruction(vote, index);
  };

  return (
    <>
      <div className="form-group mt-3">
        <label className="form-label" htmlFor="full-name">
          {t('SelectHowTheDelegateVote')}
        </label>
        <div className="row">
          <DelegationPartnerInstructionOption
            id="btnRadio1"
            value={BoardInstructionTypes.ALL_YES}
            checked={instructionType === BoardInstructionTypes.ALL_YES}
            label={t('AllYes')}
            onChange={handleChangeInstructionType}
          />
          <DelegationPartnerInstructionOption
            id="btnRadio2"
            value={BoardInstructionTypes.ALL_NO}
            checked={instructionType === BoardInstructionTypes.ALL_NO}
            label={t('AllNo')}
            onChange={handleChangeInstructionType}
          />
          <DelegationPartnerInstructionOption
            id="btnRadio3"
            value={BoardInstructionTypes.ALL_ABS}
            checked={instructionType === BoardInstructionTypes.ALL_ABS}
            label={t('AllAbs')}
            onChange={handleChangeInstructionType}
          />
          <DelegationPartnerInstructionOption
            id="btnRadio4"
            value={BoardInstructionTypes.POINT_BY_POINT}
            checked={instructionType === BoardInstructionTypes.POINT_BY_POINT}
            label={t('PointByPoint')}
            onChange={handleChangeInstructionType}
          />
        </div>
      </div>

      {instructionType === BoardInstructionTypes.POINT_BY_POINT &&
      orders.length ? (
        <>
          <label className="form-label mt-2" htmlFor="full-name">
            {t('SetOneVoteForEachPoint')}
          </label>

          {orders.map((order, index) => (
            <div
              key={order['_id']}
              className="card-inner card-bordered mt-2 round-lg"
            >
              <span className="p-2">{`${index + 1}. ${order.subject}`}</span>

              {order.voteType === voteTypes.YES_NO_ABS.value && (
                <div className="form-group p-2 mt-1">
                  <div className="row">
                    <DelegationPartnerVoteOption
                      orderId={order['_id']}
                      voteValue={voteValues.YES.value}
                      checked={
                        instructions[index].vote === voteValues.YES.value
                      }
                      label={t('Yes')}
                      onChange={(event) =>
                        handleSaveInstruction(event.target.value, index)
                      }
                    />
                    <DelegationPartnerVoteOption
                      orderId={order['_id']}
                      voteValue={voteValues.NO.value}
                      checked={instructions[index].vote === voteValues.NO.value}
                      label={t('Nope')}
                      onChange={(event) =>
                        handleSaveInstruction(event.target.value, index)
                      }
                    />
                    <DelegationPartnerVoteOption
                      orderId={order['_id']}
                      voteValue={voteValues.ABS.value}
                      checked={
                        instructions[index].vote === voteValues.ABS.value
                      }
                      label={t('Abstention')}
                      onChange={(event) =>
                        handleSaveInstruction(event.target.value, index)
                      }
                    />
                  </div>
                </div>
              )}
            </div>
          ))}
        </>
      ) : null}
    </>
  );
};

export default DelegationPartnerInstructions;
